module.exports = __webpack_public_path__ + "714fda720892af051945d7eaf64dea77.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Linkedin_20x20.svg
// module id = 156
// module chunks = 0